import {
  SelectOption,
  selectOptionActions,
} from "@/business/shared/commons/selectOption";

export const getRoles = {
  async execute(): Promise<SelectOption[]> {
    const listRoles = [
      { id: "1", value: "Administrador" },
      { id: "2", value: "Gerente" },
      { id: "3", value: "Vendedor" },
      { id: "4", value: "Cartera" },
      { id: "5", value: "Supervisor" },
      { id: "6", value: "Gestor" },
    ];

    return listRoles.map((role) =>
      selectOptionActions().create(role.id, role.value)
    );
  },
};
